<template>
    <nav v-if="isLoggedIn">
        <v-app-bar  color="indigo" dark app elevation="3" height="50">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title class="text-capitalize">
                <span>{{ name_section }}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>            
            <v-divider :vertical="true"></v-divider>
            <v-menu open-on-hover offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn
                        color="white"
                        text
                        v-on="on"
                        class="ml-3"
                    >
                        <v-icon class="mr-1">fas fa-user-circle</v-icon>
                        <span>
                            {{ currentUser.first_name }} {{ currentUser.last_name }}
                        </span>                        
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        @click="logout"
                    >
                        <v-list-item-title class="text-right">
                            Salir
                            <v-icon right>fas fa-sign-out-alt</v-icon>
                        </v-list-item-title>
                </v-list-item>
                </v-list>
            </v-menu>
            
        </v-app-bar>
        <v-navigation-drawer  v-model="drawer" app temporary width="300">            
            <v-list >
                <v-list-item router to="/dashboard" @click="selectMenuITem('Dashboard')" 
                active-class="border"
                v-if="this.$hasPermision('ver_dashboard')"
                >
                    <v-list-item-action class="icon-menu">
                        <v-icon size="16">fas fa-chart-bar</v-icon>
                    </v-list-item-action>
                    <v-list-item-content >
                        <v-list-item-title >Dashboard</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Menu Administracion ++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                <v-list-group v-if="verAdministracion()">
                    <template v-slot:activator>
                        <v-list-item-action class="icon-menu">
                            <v-icon size="16">fas fa-th-list</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Administración</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item router to="/assets" active-class="border" 
                        @click="selectMenuITem('Activos')"
                        v-if="this.$hasPermision('ver_activos')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Activos</v-list-item-title>
                        </v-list-item-content>                        
                    </v-list-item>
                    <v-list-item router to="/brands" active-class="border" 
                        @click="selectMenuITem('Marcas')"
                        v-if="this.$hasPermision('ver_marcas')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Marcas</v-list-item-title>
                        </v-list-item-content>                        
                    </v-list-item>
                    <v-list-item router to="/models" active-class="border" 
                        @click="selectMenuITem('Modelos')"
                        v-if="this.$hasPermision('ver_modelos')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Modelos</v-list-item-title>
                        </v-list-item-content>                        
                    </v-list-item>
                    <v-list-item router to="/colors" active-class="border" 
                        @click="selectMenuITem('Colores')"
                        v-if="this.$hasPermision('ver_colores')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Colores</v-list-item-title>
                        </v-list-item-content>                        
                    </v-list-item>
                    <v-list-item router to="/products" active-class="border" 
                        @click="selectMenuITem('Productos')"
                        v-if="this.$hasPermision('ver_productos')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Productos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/customers" active-class="border" 
                        @click="selectMenuITem('Clientes')"
                        v-if="this.$hasPermision('ver_clientes')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Clientes</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/providers" active-class="border" 
                        @click="selectMenuITem('Proveedores')"
                        v-if="this.$hasPermision('ver_proveedores')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Proveedores</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!--
                    <v-list-item router to="/supplies" active-class="border" 
                        @click="selectMenuITem('Insumos')"
                        v-if="this.$hasPermision('ver_insumos')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Insumos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                    
                    
                    <v-list-item router to="/mobilities" active-class="border" 
                        @click="selectMenuITem('Unidades móviles')"
                        v-if="this.$hasPermision('ver_movilidades')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Unidades móviles</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    
                    <v-list-item router to="/recipes" active-class="border" 
                        @click="selectMenuITem('Recetas')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Recetas</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    -->
                    <v-list-item router to="/variants" active-class="border" 
                        @click="selectMenuITem('Variantes')"
                        v-if="this.$hasPermision('ver_variantes')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Variantes</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <!-- Menu Logística ++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                <v-list-group v-if="verLogistica()">
                    <template v-slot:activator>
                        <v-list-item-action class="icon-menu">
                            <v-icon size="16">fas fa-industry</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Logística</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item router to="/purchases" active-class="border" 
                        @click="selectMenuITem('Compras')"
                        v-if="this.$hasPermision('ver_compras')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Compras</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/importations" active-class="border" 
                        @click="selectMenuITem('Importaciones')"
                        v-if="this.$hasPermision('ver_importaciones')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Importaciones</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!--
                    <v-list-item router to="/inventory" active-class="border" 
                        @click="selectMenuITem('Inventario de insumos')"
                        v-if="this.$hasPermision('ver_inventario')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Inventario de Insumos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    -->
                    <v-list-item router to="/products-inventory" active-class="border" 
                        @click="selectMenuITem('Inventario de productos')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Inventario de Productos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!--
                    <v-list-item router to="/storehouses" active-class="border" 
                        @click="selectMenuITem('Movimientos de almacén')"
                        v-if="this.$hasPermision('ver_storehouse')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Movimientos de almacén</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    -->
                </v-list-group>

                <!-- Menu VEntas ++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                <v-list-group v-if="verVentas()">
                    <template v-slot:activator>
                        <v-list-item-action class="icon-menu">
                            <v-icon size="16">fas fa-shopping-cart</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Ventas</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item router to="/sales" active-class="border" 
                        @click="selectMenuITem('Pedido')"
                        v-if="this.$hasPermision('ver_pedido')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Pedido</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/orders" active-class="border" 
                        @click="selectMenuITem('Salida de Pedidos')"
                        v-if="this.$hasPermision('ver_venta')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Salida de Pedidos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <!-- Menu cuentas ++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                <v-list-group v-if="verCuentas()">
                    <template v-slot:activator>
                        <v-list-item-action class="icon-menu">
                            <v-icon size="16">fas fa-coins</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Cuentas</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item router to="/provider-account" active-class="border" 
                        @click="selectMenuITem('Cuentas por pagar')"
                        v-if="this.$hasPermision('ver_cuentas')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Cuentas por pagar</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/debts" active-class="border" 
                        @click="selectMenuITem('Cuentas por cobrar')"
                        v-if="this.$hasPermision('ver_deudas')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Cuentas por cobrar</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                

                <!-- Menu Caja ----------------------------------------- -->
                <v-list-group v-if="verCaja()">
                    <template v-slot:activator>
                        <v-list-item-action class="icon-menu">
                            <v-icon size="16">fas fa-cash-register</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Caja</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item router to="/cashflow" active-class="border" 
                        @click="selectMenuITem('Caja')"
                        v-if="this.$hasPermision('ver_movimiento')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Movimientos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/history-cash" active-class="border" 
                        @click="selectMenuITem('Historial de Caja')"
                        v-if="this.$hasPermision('ver_historial')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Historial</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <!--Menu Reportes -------------------------------------- -->
                <v-list-group v-if="verReportes()">
                    <template v-slot:activator>
                        <v-list-item-action class="icon-menu">
                            <v-icon size="16">fas fa-list-alt</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Reportes</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item router to="/report-purchases" active-class="border" 
                        @click="selectMenuITem('Reporte de compras')"
                        v-if="this.$hasPermision('ver_reporte_compras')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Compras</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/report-importations" active-class="border" 
                        @click="selectMenuITem('Reporte de importaciones')"
                        v-if="this.$hasPermision('ver_reporte_importaciones')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Importaciones</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item> 
                    <v-list-item router to="/report-debts" active-class="border" 
                        @click="selectMenuITem('Reporte de deudas')"
                        v-if="this.$hasPermision('ver_reporte_deudas')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Deudas</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/report-orders" active-class="border" 
                        @click="selectMenuITem('Reporte de pedidos')"
                        v-if="this.$hasPermision('ver_reporte_pedidos')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Pedidos</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/report-sales" active-class="border" 
                        @click="selectMenuITem('Reporte de ventas')"
                        v-if="this.$hasPermision('ver_reporte_ventas')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Ventas</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/report-credit-notes" active-class="border" 
                        @click="selectMenuITem('Reporte Notas de Crédito')"
                        v-if="this.$hasPermision('ver_reporte_ventas')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Notas de Crédito</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>                  
                </v-list-group>

                <!-- Menu configuración ++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
                <v-list-group v-if="verConfiguracion()">
                    <template v-slot:activator>
                        <v-list-item-action class="icon-menu">
                            <v-icon size="16">fas fa-cogs</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Configuración</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item router to="/roles" active-class="border" 
                        @click="selectMenuITem('Roles de usuario')"
                        v-if="this.$hasPermision('ver_roles')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Roles de usuario</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item router to="/users" active-class="border" 
                        @click="selectMenuITem('Usuarios')"
                        v-if="this.$hasPermision('ver_usuarios')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Usuarios</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <!--
                    <v-list-item router to="/printers" active-class="border" 
                        @click="selectMenuITem('Impresoras')">
                        <v-list-item-content class="sub-menu">
                            <v-list-item-title >Impresoras</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    -->
                </v-list-group>

            </v-list>
      </v-navigation-drawer>
   </nav>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data: () => ({
        titleSection: 'WOST',
        drawer: false,
        optionsUser: [
            { title: 'Salir' }
        ],
        section_aministracion: 0,
        section_logistica: 0,
        section_ventas: 0
    }),
    computed: {
        ...mapState('general', [
            'name_section'
        ]),
        ...mapState('authentication', [
            'currentUser'
        ]),
        ...mapGetters('authentication', [
            'isLoggedIn',
        ]),
    },
    methods: {
        ...mapActions('general', [
            'setNameSection'
        ]),
        ...mapActions('authentication', [
            'logout',
        ]),
        selectMenuITem(text){
            this.setNameSection(text);
        },        
        verAdministracion() {
            return this.$hasPermision('ver_activos') ||
                    this.$hasPermision('ver_marcas') ||
                    this.$hasPermision('ver_modelos') ||
                    this.$hasPermision('ver_colores') ||
                    this.$hasPermision('ver_clientes') ||
                    this.$hasPermision('ver_insumos') ||
                    this.$hasPermision('ver_productos') ||
                    this.$hasPermision('ver_proveedores') ||
                    this.$hasPermision('ver_movilidades') ||
                    this.$hasPermision('ver_variantes')
        },
        verLogistica(){
            return this.$hasPermision('ver_compras') ||
                    this.$hasPermision('ver_inventario') ||
                    this.$hasPermision('ver_storehouse') ||
                    this.$hasPermision('ver_importaciones')
        },
        verVentas() {
            return this.$hasPermision('ver_pedido') || this.$hasPermision('ver_venta')
        },
        verCuentas() {
            return this.$hasPermision('ver_cuentas') || this.$hasPermision('ver_deudas')
        },
        verCaja() {
            return this.$hasPermision('ver_movimiento') || this.$hasPermision('ver_historial')
        },
        verReportes() {
            return this.$hasPermision('ver_reporte_compras') ||
                    this.$hasPermision('ver_reporte_deudas') ||
                    this.$hasPermision('ver_reporte_pedidos') ||
                    this.$hasPermision('ver_reporte_ventas') ||
                    this.$hasPermision('ver_reporte_importaciones')
        },
        verConfiguracion() {
            return this.$hasPermision('ver_roles') || this.$hasPermision('ver_usuarios')
        }
    },
    components: {
        //Popup
    },
    
}
</script>

<style>
.border {
  border-left: 4px solid #616161;
}

.icon-menu{
    margin-right: 5px !important;
}

.sub-menu{
    margin-left: 30px;
    margin-right: 0px;
}
</style>